(function (app, ng) {

    function timelineEventFiltersFactory() {
        return {
            getFilters: function (currentUserId) {
                return [
                    {
                        name: "Everyone",
                        type: "FilterByPerson",
                        isExclusive: true, //Note the isExclusive property meeans that one of filter of the same type must be turned on. Therefore there needs to be a default property
                        isDefault: true, //Note this is the default filter, which means that when a filter is truned off of the same type, this filter must be turned on
                        description: "Events created by everyone",
                        icon: "mdi-account-multiple",
                        filterEventFunction: function (event) {
                            return true;
                        },
                        turnedOn: true
                    },
                    {
                        name: "Only Me",
                        type: "FilterByPerson",
                        isExclusive: true,
                        description: "Events created only by the current user",
                        icon: "mdi-account",
                        filterEventFunction: function (event) {
                            return event.CreatedById === currentUserId;
                        },
                        turnedOn: false
                    },
                    {
                        name: "Notes",
                        type: "FilterByEventType",
                        description: "Events that are Notes",
                        icon: "mdi-message-text",
                        filterEventFunction: function (event) {
                            return event.Type === "NoteAdded";
                        },
                        turnedOn: false
                    },
                    {
                        name: "Tasks",
                        type: "FilterByEventType",
                        description: "Events that are Task Related",
                        icon: "mdi-clipboard-text",
                        filterEventFunction: function (event) {
                            return event.Type === "TaskAdded" ||
                                event.Type === "TaskCompleted" ||
                                event.Type === "TaskReassigned" ||
                                event.Type === "TaskClientUpdated" ||
                                event.Type === "TaskClientAdded" ||
                                event.Type === "TaskRescheduled";
                        },
                        turnedOn: false
                    },
                    {
                        name: "Marketing Events",
                        type: "FilterByEventType",
                        description: "Attended Marketing Events from Marketing Tracker",
                        icon: "mdi-format-list-bulleted",
                        filterEventFunction: function (event) {
                            return event.Type === "MarketingEventAttended";
                        },
                        turnedOn: false
                    },
                    {
                        name: "Appointments",
                        type: "FilterByEventType",
                        description: "Events that are Appointment Related",
                        icon: "mdi-calendar",
                        filterEventFunction: function (event) {
                            return event.Type === "AppointmentAdded" ||
                                event.Type === "AppointmentCompleted" ||
                                event.Type === "AppointmentAttendeeRemoved" ||
                                event.Type === "AppointmentMainAttendeeUpdated" ||
                                event.Type === "AppointmentRescheduled";
                        },
                        turnedOn: false
                    },
                    {
                        name: "Cases",
                        type: "FilterByEventType",
                        description: "Events that are Case Related",
                        icon: "mdi-briefcase",
                        filterEventFunction: function (event) {
                            return event.Type === "CaseCreated" ||
                                event.Type === "InvestmentAccountCreated" ||
                                event.Type === "AnnuityAccountCreated" ||
                                event.Type === "LifeAccountCreated" ||
                                event.Type === "LongTermCareAccountCreated" ||
                                event.Type === "CasePlanningNoteAdded" ||
                                event.Type === "InvestmentAccountNoteAdded" ||
                                event.Type === "InsuranceAccountNoteAdded";
                        },
                        turnedOn: false
                    }
                ];
            }
        };
    }

    app.factory("timelineEventFiltersFactory", timelineEventFiltersFactory);

})(window.app, window.angular); //jshint ignore:line